import { BindAll } from 'lodash-decorators';
import React from 'react';
import styles from './styles.module.less';
import XiaoZhi from './xiaozhi';

@BindAll()
export default class Widgets extends React.Component {
  get UserInfo() {
    return this.$Store.UserInfo;
  }
  get System() {
    return this.$Store.System;
  }
  get User() {
    return this.$Store.UserInfo.User;
  }
  renderWidgets() {
    return (
      <div className={styles.widgets}>
        <XiaoZhi />
      </div>
    );
  }
  render() {
    return <>{this.renderWidgets()}</>;
  }
}
